import { LoadingState } from "@/ds/custom/LoadingState";
import { ErrorDisplay } from "@/lib/common/ErrorDisplay";
import type { ProblemResponse } from "@/lib/http";
import type { ReactNode } from "react";

export interface QueryStateQuery<T> {
	data: T | undefined;
	isError: boolean;
	error: ProblemResponse | null;
}

export interface QueryStateProps<T> {
	query: QueryStateQuery<T>;
	children: (data: T) => ReactNode;
	isEmpty?: (data: T) => boolean;
	empty?: ReactNode;
	loading?: ReactNode;
}

export const QueryState = <T,>(props: QueryStateProps<T>): React.JSX.Element => {
	const {
		query,
		children,
		isEmpty,
		empty,
		loading
	} = props;

	if (query.isError) {
		return (
			<div className="p-3">
				<ErrorDisplay error={query.error} />
			</div>
		);
	}

	if (query.data === undefined) {
		return <>{loading ?? <LoadingState />}</>;
	}

	if (empty && isEmpty && isEmpty(query.data)) {
		return <>{empty}</>;
	}

	return <>{children(query.data)}</>;
};
